<!--
	Collapsible panel hosting the SafeIntersections crash-risk calculator.
	Shown only for Identify (intersection) features — Prioritize and accident
	features have no interventions to test.

	The calculator is keyed on the selected feature so its proposed-input
	$state re-initialises per selection (no sync effects).
-->
<script lang="ts">
	import { featureSelectionStore } from '#lib/stores/featureSelectionStore.svelte.js';
	import CollapsiblePanel from '#lib/components/CollapsiblePanel.svelte';
	import { EIdentify } from '../interfaces';
	import Calculator from './Calculator.svelte';

	const feature = $derived(featureSelectionStore.current);
	const systemId = $derived(featureSelectionStore.currentSystemId);

	const showPanel = $derived(!!feature && systemId === EIdentify.Identify);
</script>

{#if showPanel && feature}
	<CollapsiblePanel title="Interventions" grow>
		{#key feature}
			<Calculator {feature} />
		{/key}
	</CollapsiblePanel>
{/if}
